import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineExternalLinkAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18 10.82a1.0001 1.0001 0 0 0-1 1V19a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V8a1 1 0 0 1 1-1h7.18a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11a3 3 0 0 0 3-3v-7.18a1.0001 1.0001 0 0 0-1-1Zm3.92-8.2a1.0002 1.0002 0 0 0-.54-.54A.9998.9998 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.59L8.29 14.29a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71 1.001 1.001 0 0 0 .71.2958.9994.9994 0 0 0 .71-.2958L20 5.41V9a1.0002 1.0002 0 0 0 1.7071.7071A1.0002 1.0002 0 0 0 22 9V3a1.0011 1.0011 0 0 0-.08-.38Z"/>
  </SvgIcon>
}

export default LineExternalLinkAltIcon
